;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  var dependencies = []

  angular.module('app.zone', dependencies).config(config)

  /* @ngInject */
  function config($stateProvider) {
    var options = {
      templateUrl: 'zone.html',
      controller: 'Zone',
      controllerAs: '$ctrl',
      tags: {
        description:
          'Quickly give feedback about products that display a Glow ' +
          'product sticker for a chance to win great prizes every month.',
      },
    }

    $stateProvider.state(
      'app.zone',
      _.defaults(
        {
          url: '/zone?referrer&code',
        },
        options
      )
    )

    $stateProvider.state(
      'app.zoneCustom',
      _.defaults(
        {
          url: '/zone/:themeName?referrer&code',
        },
        options
      )
    )
  }
})()
